/* v34: cores da opcao 'Cor' (portugues) na lingua da pagina - igual ao snippet pe-cor */
window.PE_COR=window.PE_COR||(function(){var M={"Preto":["Black","Negro","Noir","Schwarz","Nero"],"Branco":["White","Blanco","Blanc","Weiß","Bianco"],"Branco-sujo":["Off-white","Blanco roto","Blanc cassé","Altweiß","Bianco sporco"],"Cinzento":["Grey","Gris","Gris","Grau","Grigio"],"Antracite":["Anthracite","Antracita","Anthracite","Anthrazit","Antracite"],"Azul":["Blue","Azul","Bleu","Blau","Blu"],"Azul-claro":["Light blue","Azul claro","Bleu clair","Hellblau","Azzurro"],"Azul-marinho":["Navy","Azul marino","Bleu marine","Marineblau","Blu navy"],"Verde":["Green","Verde","Vert","Grün","Verde"],"Verde-militar":["Military green","Verde militar","Vert kaki","Militärgrün","Verde militare"],"Vermelho":["Red","Rojo","Rouge","Rot","Rosso"],"Bordo":["Burgundy","Burdeos","Bordeaux","Bordeaux","Bordeaux"],"Rosa":["Pink","Rosa","Rose","Rosa","Rosa"],"Fucsia":["Fuchsia","Fucsia","Fuchsia","Fuchsia","Fucsia"],"Coral":["Coral","Coral","Corail","Koralle","Corallo"],"Roxo":["Purple","Morado","Violet","Lila","Viola"],"Laranja":["Orange","Naranja","Orange","Orange","Arancione"],"Amarelo":["Yellow","Amarillo","Jaune","Gelb","Giallo"],"Bege":["Beige","Beige","Beige","Beige","Beige"],"Areia":["Sand","Arena","Sable","Sand","Sabbia"],"Creme":["Cream","Crema","Crème","Creme","Crema"],"Cru":["Ecru","Crudo","Écru","Ecru","Ecrù"],"Marfim":["Ivory","Marfil","Ivoire","Elfenbein","Avorio"],"Taupe":["Taupe","Topo","Taupe","Taupe","Tortora"],"Camel":["Camel","Camel","Camel","Camel","Cammello"],"Caqui":["Khaki","Caqui","Kaki","Khaki","Cachi"],"Castanho":["Brown","Marrón","Marron","Braun","Marrone"],"Dourado":["Gold","Dorado","Doré","Gold","Oro"],"Prateado":["Silver","Plateado","Argenté","Silber","Argento"],"Bronze":["Bronze","Bronce","Bronze","Bronze","Bronzo"],"Ganga":["Denim","Denim","Denim","Denim","Denim"],"Estampado":["Print","Estampado","Imprimé","Gemustert","Fantasia"]},L=['en','es','fr','de','it'];var li=L.indexOf(String(document.documentElement.lang||'').slice(0,2).toLowerCase());return function(v){v=String(v||'');if(li<0)return v;return v.split(' e ').map(function(p){p=p.trim();var m=p.match(/^(.*?)( \d+)?$/);var b=m[1],n=m[2]||'';return (M[b]?M[b][li]:b)+n;}).join(' / ');};})();
/* ═══════════════════════════════════════════════════════════
   pe-cart.js — PureEthical Cart v3 — Clean & Reliable
   ═══════════════════════════════════════════════════════════ */
'use strict';
/* security 2026-10-05: escaping helpers (HTML text/attributes and same-origin relative URLs) */
var PE_esc = window.PE_esc || function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); };
var PE_url = window.PE_url || function (u, fb) { u = String(u == null ? '' : u); return /^\/(?!\/)/.test(u) ? PE_esc(u) : PE_esc(fb || '/'); };
var PE_img = window.PE_img || function (u) { u = String(u == null ? '' : u); return /^(https:)?\/\/[^\s"'<>]+$|^\/(?!\/)[^\s"'<>]*$/.test(u) ? PE_esc(u) : ''; };
window.PE_esc = PE_esc; window.PE_url = PE_url; window.PE_img = PE_img;


/* ── Helpers ── */
function PE_qs(s) { return document.querySelector(s); }
function PE_money(cents) {
  if (!window.Shopify || !Shopify.currency) return (cents/100).toFixed(2).replace('.', ',') + ' €';
  var sym = {'EUR':'€','CHF':'CHF ','GBP':'£','USD':'$'}[Shopify.currency.active] || '';
  var val = (cents/100).toFixed(2).replace('.',',');
  /* v27: euro no formato portugues - "1 234,90 €" */
  if (Shopify.currency.active === 'EUR') {
    var p = val.split(','); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return p.join(',') + ' €';
  }
  return sym + val;
}

/* ── Cart API ─────────────────────────────────────────────── */
function cartAdd(id, qty, ok, fail) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
    body: JSON.stringify({id: parseInt(id,10), quantity: qty || 1})
  })
  .then(function(r) {
    if (!r.ok) return r.json().then(function(d){ throw new Error(d.description||d.error||'Error'); });
    return r.json();
  })
  .then(function(d) { if (ok) ok(d); })
  .catch(function(e) { if (fail) fail(e.message); });
}

function cartChange(key, qty, cb) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
    body: JSON.stringify({id: key, quantity: qty})
  })
  .then(function(r){ return r.json(); })
  .then(function(d){ refreshCart(d); if(cb) cb(d); })
  .catch(function(){});
}

function getCart(cb) {
  fetch('/cart.js?t=' + Date.now())
    .then(function(r){ return r.json(); })
    .then(function(d){ if(cb) cb(d); })
    .catch(function(){});
}

/* ── Shipping bar ─────────────────────────────────────────── */
/* v43: tira a marca do inicio do nome (a marca ja aparece por cima), sem distinguir acentos/maiusculas */
function peStripBrand(t, v) {
  t = String(t || ''); v = String(v || '');
  if (!v) return t;
  var n = function (x) { try { return x.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); } catch (e) { return x.toLowerCase(); } };
  var nt = n(t), nv = n(v);
  if (nt.indexOf(nv) === 0) { var r = t.slice(v.length).replace(/^[\s\-–—·]+/, ''); if (r.length > 1) return r; }
  return t;
}
var FREE_THRESHOLD = window.PE_FREE_THRESHOLD || 8900; /* cents; set in Theme settings → Cart & Shipping */
function updateShippingBar(total) {
  var bar = PE_qs('#cdShippingBar');
  if (!bar) return;
  /* IMPORTANT: keep the outer .cd-shipping-bar class intact — this element
     carries the container padding. A previous version of this function
     overwrote bar.className entirely (to cd-shipping-msg / cd-shipping-ok,
     classes with no styling at all), which silently dropped the padding
     the moment the cart refreshed after adding an item. Only innerHTML
     should change here; the outer class stays as-is. */
  var remaining = Math.max(0, FREE_THRESHOLD - total);
  var truckIcon = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
  var checkIcon = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg>';
  if (remaining === 0) {
    bar.innerHTML =
      '<div class="cd-ship-inner cd-ship-done">' +
        checkIcon +
        ' ' + window.PE_T('free_unlocked_html','You\'ve unlocked <strong>FREE shipping!</strong>') +
      '</div>';
  } else {
    var pct = Math.min(99, Math.floor((total / FREE_THRESHOLD) * 100)); /* v43: nunca 100% enquanto faltar dinheiro */
    bar.innerHTML =
      '<div class="cd-ship-inner">' +
        '<div class="cd-ship-row">' +
          truckIcon +
          '<span>' + window.PE_T('spend_more_html','Spend <strong>@@AMT@@</strong> more for free shipping').replace('@@AMT@@', PE_money(remaining)) + '</span>' +
          '<span class="cd-ship-pct">' + pct + '%</span>' +
        '</div>' +
        '<div class="cd-progress-bar"><div class="cd-progress-fill" style="width:' + pct + '%"></div></div>' +
      '</div>';
  }
}

/* ── Render cart ──────────────────────────────────────────── */
function refreshCart(data) {
  var body  = document.getElementById('cdBody');
  var foot  = document.getElementById('cdFoot');
  var badge = document.querySelector('.cart-pill');
  var count = (data && data.item_count) ? parseInt(data.item_count,10) : 0;
  var total = (data && data.total_price) ? data.total_price : 0;
  if (data && data.items && data.items.length) { var _peDT = 0; for (var _pi = 0; _pi < data.items.length; _pi++) { var _it = data.items[_pi]; _peDT += (_it.final_line_price != null ? _it.final_line_price : (_it.final_price * _it.quantity)); } if (_peDT > 0) total = _peDT; }
  var items = (data && data.items) ? data.items : [];

  /* Badge */
  if (badge) {
    badge.textContent = count > 0 ? count : '';
    badge.style.display = count > 0 ? '' : 'none';
  }

  /* v30 Fase 1G: contador no titulo da gaveta (so era escrito pelo Liquid ao carregar a pagina e ficava desatualizado) */
  var cdCountEl = document.getElementById('cdCount');
  if (cdCountEl) cdCountEl.textContent = count > 0 ? count : '';

  /* Shipping bar */
  updateShippingBar(total);

  /* Footer — always visible when has items */
  if (foot) {
    foot.style.display = count > 0 ? 'block' : 'none';
    /* Update subtotal */
    var subEl = document.getElementById('cdSubtotal');
    var ckPrEl = document.getElementById('cdCheckoutPrice');
    var moneyStr = PE_money(total);
    if (subEl) subEl.textContent = moneyStr;
    if (ckPrEl) ckPrEl.textContent = moneyStr;
    /* v27: portes gratis acima do limite */
    var shipEl = document.getElementById('cdShipVal');
    if (shipEl) shipEl.textContent = total >= FREE_THRESHOLD ? window.PE_T('ship_free','Free') : PE_money(1390); /* v43: portes fixos 13,90 na UE */
    /* Checkout URL with optional discount */
    var ckBtn = document.querySelector('.cd-checkout-btn');
    if (ckBtn) {
      var code = '';
      try { code = sessionStorage.getItem('pe_discount_code') || ''; } catch(e){}
      ckBtn.href = code ? '/checkout?discount=' + encodeURIComponent(code) : '/checkout';
    }
    /* Savings: covers automatic discounts, compare_at_price (sale price), code discounts */
    var saved = 0;
    items.forEach(function(item) {
      var orig  = item.original_line_price  || (item.original_price  * item.quantity);
      var final_ = item.final_line_price || (item.final_price * item.quantity);
      /* Cart-level discounts (codes, automatic discounts applied at checkout) */
      if (orig > final_) saved += (orig - final_);
      /* Product-level sale price: compare_at_price vs the actual selling price.
         This is the "-20%" badge / crossed-out price on the PLP — Shopify does
         NOT fold this into original_price/final_price on its own, so it has to
         be added separately or items on sale never show any savings here. */
      /* v30 F0.5: o compare_at_price deixou de contar como poupanca - nao e um preco anterior documentado.
         So contam descontos reais aplicados pela Shopify (codigos e descontos automaticos), acima. */
    });
    var savedRow = document.getElementById('cdSavedRow');
    var savedAmt = document.getElementById('cdSavedAmt');
    if (savedRow) savedRow.style.display = saved > 0 ? 'flex' : 'none';
    if (savedAmt) savedAmt.textContent = PE_money(saved);
  }

  if (!body) return;

  /* Empty state */
  if (count === 0) {
    body.innerHTML = '<div class="cd-empty">' +
      '<div class="cd-empty-icon"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ddd" stroke-width="1" stroke-linecap="round"><path d="M6 2 3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg></div>' +
      '<h3 class="cd-empty-title">' + window.PE_T('empty_title','Your bag is empty') + '</h3>' +
      '<p class="cd-empty-sub">' + window.PE_T('discover','Discover our collection') + '</p>' +
      '<a href="' + (((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'collections/all') + '" class="cd-empty-btn">' + window.PE_T('shop_now','Shop now') + '</a></div>'; /* v30 Fase 1G: com o prefixo da lingua */
    peCdRestoreFocus();
    return;
  }

  /* Items */
  var html = '<div class="cd-items-list">';
  items.forEach(function(item) {
    /* Image */
    var img = (item.featured_image && item.featured_image.url) ? item.featured_image.url :
              (item.image || '');
    if (img && img.slice(0,2) === '//') img = 'https:' + img;

    /* Variant text */
    var opts = (item.options_with_values || [])
      .filter(function(o) { return o.name && o.name.toLowerCase() !== 'title'; })
      .map(function(o) { return /^(cor|colou?r|colore|farbe|couleur|herz)$/i.test(o.name) ? window.PE_COR(o.value) : o.value; })
      .join(' / ');

    /* Price */
    var finalP = item.final_line_price || (item.final_price * item.quantity);
    var origP  = item.original_line_price || (item.original_price * item.quantity);
    var hasSale = origP > finalP;

    html += '<div class="cd-item" data-key="' + PE_esc(item.key) + '">' +
      /* Image */
      '<a href="' + PE_url(item.url, '/') + '" class="cd-item-img" tabindex="-1" aria-hidden="true">' +
        (PE_img(img) ? '<img src="' + PE_img(img) + '" alt="" onerror="this.parentNode.style.background=\'#f5f5f5\';this.remove()">' :
               '<div class="cd-item-img-ph"></div>') +
      '</a>' +
      /* Content */
      '<div class="cd-item-body">' +
        '<div class="cd-item-top">' +
          '<div>' +
            (item.vendor ? '<p class="cd-item-brand">' + PE_esc(item.vendor) + '</p>' : '') +
            '<a href="' + PE_url(item.url, '/') + '" class="cd-item-name">' + PE_esc(peStripBrand(item.product_title || item.title, item.vendor)) + '</a>' +
            (opts ? '<p class="cd-item-variant">' + PE_esc(opts) + '</p>' : '') +
          '</div>' +
          '<button class="cd-remove-btn" data-key="' + PE_esc(item.key) + '" data-variant-id="' + (parseInt(item.variant_id,10)||0) + '" data-qty="' + (parseInt(item.quantity,10)||0) + '" data-title="' + PE_esc(item.product_title || item.title || '') + '" type="button" aria-label="' + window.PE_T('remove','Remove') + ': ' + (item.product_title || item.title || '').replace(/"/g,'&quot;') + '">' + /* v30 Fase 1J: o nome diz qual artigo */
            '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="cd-item-foot">' +
          '<div class="qty-step" data-key="' + PE_esc(item.key) + '">' +
            '<button class="qty-step-btn" data-act="minus" type="button" aria-label="' + window.PE_T('qty_dec','Decrease') + ': ' + PE_esc(item.product_title || item.title || '') + '">−</button>' + /* v30 Fase 1G: nome para leitores de ecra; Fase 1P: com o artigo, como no "Remover" */
            '<span class="qty-step-val">' + (parseInt(item.quantity,10)||0) + '</span>' +
            '<button class="qty-step-btn" data-act="plus" type="button" aria-label="' + window.PE_T('qty_inc','Increase') + ': ' + PE_esc(item.product_title || item.title || '') + '">+</button>' +
          '</div>' +
          '<div class="cd-item-prices">' +
            (hasSale ? '<s class="cd-item-original">' + PE_money(origP) + '</s>' : '') +
            '<span class="cd-item-price' + (hasSale ? ' cd-item-sale' : '') + '">' + PE_money(finalP) + '</span>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  });
  html += '</div>';
  body.innerHTML = html;

  /* Attach events */
  body.querySelectorAll('.cd-remove-btn').forEach(function(btn, rIdx) {
    btn.addEventListener('click', function() {
      peCdFocus = { idx: rIdx };
      var variantId = btn.dataset.variantId;
      var qty = parseInt(btn.dataset.qty, 10) || 1;
      var title = btn.dataset.title || 'Item';
      btn.style.opacity = '0.3';
      cartChange(btn.dataset.key, 0, function() {
        peShowUndoToast(title, variantId, qty);
      });
    });
  });
  body.querySelectorAll('.qty-step').forEach(function(step) {
    step.querySelectorAll('.qty-step-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var val = parseInt(step.querySelector('.qty-step-val').textContent, 10) || 1;
        var newQ = btn.dataset.act === 'plus' ? val + 1 : Math.max(0, val - 1);
        peCdFocus = { key: step.dataset.key, act: btn.dataset.act, idx: Array.prototype.indexOf.call(body.querySelectorAll('.qty-step'), step) };
        btn.disabled = true;
        cartChange(step.dataset.key, newQ, null);
      });
    });
  });
  peCdRestoreFocus();
}

/* v30 Fase 1J: a gaveta e redesenhada a cada alteracao (innerHTML) e o foco do teclado perdia-se.
   Depois de mudar a quantidade volta ao mesmo botao; depois de remover vai para o artigo seguinte,
   ou para o botao da gaveta vazia / fechar. So quando a gaveta esta aberta. */
var peCdFocus = null;
function peCdRestoreFocus() {
  var f = peCdFocus; peCdFocus = null;
  if (!f) return;
  var dr = document.getElementById('cartDrawer');
  if (!dr || !dr.classList.contains('on')) return;
  var t = null;
  if (f.key && f.act) t = dr.querySelector('.qty-step[data-key="' + f.key + '"] .qty-step-btn[data-act="' + f.act + '"]');
  if (!t && typeof f.idx === 'number') { var rs = dr.querySelectorAll('.cd-remove-btn'); if (rs.length) t = rs[Math.min(f.idx, rs.length - 1)]; }
  if (!t) t = dr.querySelector('.cd-empty-btn') || document.getElementById('cartClose');
  if (t) { try { t.focus({ preventScroll: true }); } catch (e) {} }
}

/* ── Undo toast ───────────────────────────────────────────
   Shown after removing an item. Clicking Undo re-adds the exact
   same variant + quantity that was just removed. Auto-dismisses
   after 5s. This is the "undo" feature referenced in theme.js
   but never actually built — implemented here. ── */
var peUndoTimer = null;
function peShowUndoToast(title, variantId, qty) {
  var existing = document.getElementById('peUndoToast');
  if (existing) existing.remove();
  if (peUndoTimer) clearTimeout(peUndoTimer);

  var shortTitle = title.length > 28 ? title.slice(0, 28) + '…' : title;

  var toast = document.createElement('div');
  toast.id = 'peUndoToast';
  toast.setAttribute('role', 'status');
  toast.style.cssText = [
    'position:fixed;left:50%;bottom:24px;transform:translateX(-50%) translateY(0);',
    'z-index:99999;display:flex;align-items:center;gap:14px;',
    'background:#111;color:#fff;border-radius:10px;',
    'padding:13px 16px 13px 18px;box-shadow:0 12px 32px rgba(0,0,0,.28);',
    'font-family:var(--fb, sans-serif);font-size:13px;font-weight:500;',
    'max-width:calc(100vw - 32px);animation:peUndoIn 260ms cubic-bezier(0.16,1,.3,1)'
  ].join('');

  var msg = document.createElement('span');
  /* v30 Fase 1J: texto na lingua da pagina (era "... removed" em ingles); escrito depois de o aviso entrar na pagina para ser anunciado */
  var peMsgTxt = (window.PE_T ? window.PE_T('removed', 'Removed') : 'Removed') + ': ' + shortTitle;
  msg.style.cssText = 'white-space:nowrap;overflow:hidden;text-overflow:ellipsis;';

  var undoBtn = document.createElement('button');
  undoBtn.type = 'button';
  undoBtn.textContent = (window.PE_T?window.PE_T('undo','Undo'):'Undo');
  undoBtn.style.cssText = [
    'flex-shrink:0;background:none;border:none;color:#fff;',
    'font-weight:800;font-size:13px;letter-spacing:.02em;cursor:pointer;',
    'text-decoration:underline;text-underline-offset:3px;padding:0;'
  ].join('');
  undoBtn.addEventListener('click', function() {
    undoBtn.disabled = true;
    undoBtn.style.opacity = '.5';
    if (variantId) {
      cartAdd(variantId, qty, function() {
        getCart(refreshCart);
        peDismissUndoToast();
      }, function() { peDismissUndoToast(); });
    } else {
      peDismissUndoToast();
    }
  });

  var closeBtn = document.createElement('button');
  closeBtn.type = 'button';
  closeBtn.setAttribute('aria-label', window.PE_T('dismiss','Dismiss'));
  closeBtn.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
  closeBtn.style.cssText = 'flex-shrink:0;background:none;border:none;color:rgba(255,255,255,.5);cursor:pointer;display:flex;padding:0;';
  closeBtn.addEventListener('click', peDismissUndoToast);

  toast.appendChild(msg);
  toast.appendChild(undoBtn);
  toast.appendChild(closeBtn);
  document.body.appendChild(toast);
  setTimeout(function () { msg.textContent = peMsgTxt; }, 60);

  peUndoTimer = setTimeout(peDismissUndoToast, 5000);
}
function peDismissUndoToast() {
  var toast = document.getElementById('peUndoToast');
  if (!toast) return;
  toast.style.animation = 'peUndoOut 200ms ease forwards';
  setTimeout(function() { if (toast.parentNode) toast.remove(); }, 200);
  if (peUndoTimer) { clearTimeout(peUndoTimer); peUndoTimer = null; }
}
(function peInjectUndoStyles() {
  if (document.getElementById('peUndoStyles')) return;
  var style = document.createElement('style');
  style.id = 'peUndoStyles';
  style.textContent =
    '@keyframes peUndoIn{from{opacity:0;transform:translateX(-50%) translateY(12px)}to{opacity:1;transform:translateX(-50%) translateY(0)}}' +
    '@keyframes peUndoOut{from{opacity:1;transform:translateX(-50%) translateY(0)}to{opacity:0;transform:translateX(-50%) translateY(12px)}}';
  document.head.appendChild(style);
})();
window.peShowUndoToast = peShowUndoToast;


/* NOTE: opening/closing the cart drawer is owned exclusively by the
   global menu/panel script in layout/theme.liquid (openCart/closeAll,
   exposed as window.openCart/window.closeCart). This file used to define
   its OWN openCart()/closeCart() and re-assign window.openCart/
   window.closeCart to them — since both scripts declared a function with
   the same name and both wrote to window.openCart, whichever loaded last
   won, and the two implementations toggled two DIFFERENT overlay elements
   (#cartOverlay here vs. a dynamically-created backdrop in theme.liquid).
   Closing via the header's X button always cleaned up the theme.liquid
   backdrop, but if the drawer had been opened via window.openCart() from
   pe-product-card.js while this file's version currently "owned" that
   global, #cartOverlay was left with its "on" class forever — a stuck,
   half-dark, unclickable page. Removed here so there is exactly one
   owner of the open/close state. */

/* ── Cart bump animation ─────────────────────────────────── */
function peBumpCart(n) {
  var badge = document.querySelector('.cart-pill');
  if (!badge) return;
  if (typeof n !== 'undefined') {
    badge.textContent = n > 0 ? n : '';
    badge.style.display = n > 0 ? '' : 'none';
  }
  badge.style.animation = 'none';
  void badge.offsetWidth;
  badge.style.animation = 'cinCartBump 380ms cubic-bezier(0.34,1.56,0.64,1)';
  setTimeout(function() { badge.style.animation = ''; }, 450);
}


/* ── Discount eligibility popup ────────────────────────── */
/* v42 auditoria D: janela refeita - textos na lingua da pagina (PE_T), preto e branco de cantos retos,
   role="dialog" com foco no botao fechar, Tab preso dentro, Escape fecha e o foco volta ao "Aplicar". */
function showDiscountPopup(code, cartItems) {
  var existing = document.getElementById('cdDiscPopup');
  if (existing) existing.remove();
  /* o filtro t da Liquid devolve o texto ja' escapado (&#39;); desfaz-se aqui e volta a escapar-se com PE_esc */
  var T = function (k, f) { var v = String(window.PE_T ? window.PE_T(k, f) : f); return v.replace(/&#39;/g, "'").replace(/&quot;/g, '"').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&'); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var back = document.activeElement;

  var overlay = document.createElement('div');
  overlay.id = 'cdDiscPopup';
  overlay.style.cssText = 'position:fixed;inset:0;z-index:300000;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.45);padding:20px;animation:peDiscIn 220ms cubic-bezier(0.16,1,.3,1)';

  var panel = document.createElement('div');
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-modal', 'true');
  panel.setAttribute('aria-labelledby', 'cdDiscPopupT');
  panel.style.cssText = 'background:#fff;border-radius:0;max-width:400px;width:100%;box-shadow:0 24px 64px rgba(0,0,0,.18);overflow:hidden;color:#111;';

  var items = (cartItems || []).map(function (item) {
    var img = (item.featured_image && item.featured_image.url) ? item.featured_image.url : (item.image || '');
    if (img && img.slice(0, 2) === '//') img = 'https:' + img;
    return '<li style="display:flex;align-items:center;gap:12px;padding:10px 0;border-top:1px solid #E6E6E3;">' +
      '<span style="width:44px;height:58px;flex-shrink:0;background:#EEEEEE;display:block;overflow:hidden;">' +
        (PE_img(img) ? '<img src="' + PE_img(img) + '" alt="" style="width:100%;height:100%;object-fit:contain;mix-blend-mode:multiply;padding:8%;box-sizing:border-box">' : '') +
      '</span>' +
      '<span style="flex:1;min-width:0;font-size:12.5px;line-height:1.4;">' + PE_esc(item.product_title || item.title) + '</span>' +
    '</li>';
  }).join('');

  panel.innerHTML =
    '<div style="display:flex;align-items:flex-start;justify-content:space-between;gap:12px;padding:18px 20px 14px;border-bottom:1px solid #E6E6E3;">' +
      '<div><p style="margin:0;font-size:10.5px;font-weight:600;letter-spacing:.16em;text-transform:uppercase;color:#4A4A45">' + PE_esc(T('disc_code', 'Discount code')) + '</p>' +
      '<p style="margin:6px 0 0;font-size:15px;font-weight:600;letter-spacing:.06em">' + PE_esc(code) + '</p></div>' +
      '<button type="button" id="cdDiscPopupClose" aria-label="' + PE_esc(T('dismiss', 'Close')) + '" style="width:36px;height:36px;margin:-6px -8px 0 0;border:0;border-radius:0;background:none;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#111">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
      '</button>' +
    '</div>' +
    '<div style="padding:16px 20px 20px;">' +
      '<p id="cdDiscPopupT" style="margin:0 0 6px;font-size:14px;font-weight:600">' + PE_esc(T('code_invalid_items', 'Code not valid for current items')) + '</p>' +
      '<p style="margin:0 0 14px;font-size:12.5px;line-height:1.55;color:#4A4A45">' + PE_esc(T('code_specific', 'This code applies to specific products. Add the eligible products to your bag.')) + '</p>' +
      (items ? '<p style="margin:0 0 4px;font-size:10.5px;font-weight:600;letter-spacing:.14em;text-transform:uppercase;color:#4A4A45">' + PE_esc(T('disc_bag', 'Your bag (not eligible)')) + '</p><ul style="list-style:none;margin:0 0 16px;padding:0;border-bottom:1px solid #E6E6E3;">' + items + '</ul>' : '') +
      /* NOTE: Shopify does not expose, to theme code, which products a discount code is restricted to.
         The merchant keeps a "descontos" collection with exactly the products the live codes apply to. */
      '<a href="' + PE_esc(root + 'collections/descontos') + '" style="display:flex;align-items:center;justify-content:center;height:50px;background:#000;color:#fff;border-radius:0;font-size:12px;font-weight:500;letter-spacing:.16em;text-transform:uppercase;text-decoration:none">' + PE_esc(T('disc_browse', 'Browse eligible products')) + '</a>' +
      '<p style="margin:10px 0 0;font-size:11.5px;color:#4A4A45;text-align:center">' + PE_esc(T('disc_or_checkout', 'Or enter the code at checkout to confirm eligibility')) + '</p>' +
    '</div>';

  overlay.appendChild(panel);
  document.body.appendChild(overlay);

  function closePopup() {
    document.removeEventListener('keydown', onKey, true);
    overlay.remove();
    var t = document.getElementById('cdDiscountApply') || back;
    if (t && t.focus) { try { t.focus({ preventScroll: true }); } catch (e) {} }
  }
  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); closePopup(); return; }
    if (e.key !== 'Tab') return;
    var f = panel.querySelectorAll('a[href],button');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closePopup(); });
  var closeBtn = document.getElementById('cdDiscPopupClose');
  if (closeBtn) { closeBtn.addEventListener('click', closePopup); try { closeBtn.focus({ preventScroll: true }); } catch (e) {} }
  document.addEventListener('keydown', onKey, true);
}

/* ── "descontos" collection membership check ──────────────────────────
   Fetches product ids from /collections/descontos/products.json (the
   merchant keeps this collection in sync with live discount codes) and
   reports whether any cart item belongs to it. Cached per page load. */
var _descontosIds = null;
function checkDescontosCollection(cartItems) {
  function idsFromPages(page, acc) {
    return fetch('/collections/descontos/products.json?limit=250&page=' + page)
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        var prods = (data && data.products) || [];
        prods.forEach(function (p) { acc.push(p.id); });
        if (prods.length === 250 && page < 4) return idsFromPages(page + 1, acc);
        return acc;
      })
      .catch(function () { return acc; });
  }
  var idsPromise = _descontosIds
    ? Promise.resolve(_descontosIds)
    : idsFromPages(1, []).then(function (ids) { _descontosIds = ids; return ids; });

  return idsPromise.then(function (ids) {
    if (!ids.length) return true; /* collection missing/unreadable → don't block: checkout decides */
    return (cartItems || []).some(function (it) {
      return ids.indexOf(it.product_id) > -1;
    });
  });
}

/* ── Discount code — validate against Shopify, check cart eligibility ── */
(function() {
  var input    = document.getElementById('cdDiscountInput');
  var applyBtn = document.getElementById('cdDiscountApply');
  var msg      = document.getElementById('cdDiscountMsg');
  if (!input || !applyBtn) return;

  function showMsg(text, type) {
    if (!msg) return;
    msg.style.display = 'flex';
    msg.style.color   = type === 'ok' ? '#111111' : (type === 'warn' ? '#8A5A00' : '#B3261E'); /* v42: sem verde */
    /* the Liquid t filter HTML-escapes translations; textContent would show &quot; literally */
    text = String(text).replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
    msg.textContent   = (type === 'ok' ? '✓ ' : (type === 'err' ? '✗ ' : '⚠ ')) + text; /* v27: textContent - o codigo vem do cliente */
  }
  function hideMsg() { if (msg) msg.style.display = 'none'; }

  /* Restore saved code */
  try {
    var saved = sessionStorage.getItem('pe_discount_code');
    if (saved) { input.value = saved; showMsg(window.PE_T('code_saved','Code "{code}" will apply at checkout').replace('{code}', saved), 'ok'); }
  } catch(e){}

  function applyCode() {
    var code = input.value.trim().toUpperCase();
    if (!code) { showMsg(window.PE_T('enter_discount','Please enter a discount code'), 'err'); return; }

    applyBtn.disabled    = true;
    applyBtn.textContent = '...';
    hideMsg();

    /* Step 1: Record prices BEFORE applying discount */
    fetch('/cart.js?t=' + Date.now())
    .then(function(r){ return r.json(); })
    .then(function(cartBefore) {
      var totalBeforeDiscount = cartBefore.items.reduce(function(sum, item) {
        return sum + (item.final_line_price || item.final_price * item.quantity);
      }, 0);

      /* Step 2: Apply the code to the CART itself via /cart/update.js.
         NOTE: the old version of this code used GET /discount/{code}, which
         only sets a checkout-time cookie — it never changes cart.js totals
         at all, for any code, valid or not. Comparing cart totals before/
         after that call could therefore NEVER detect a real discount, so
         every code always fell through to "not eligible", even correctly
         configured ones. /cart/update.js with a discount param is Shopify's
         actual cart-level discount API and DOES update item pricing /
         cart.total_price immediately, so the before/after comparison below
         now measures something real. */
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
        body: JSON.stringify({ discount: code })
      })
      .then(function(r){ return r.json(); })
      .then(function(cartAfter) {
        applyBtn.disabled    = false;
        applyBtn.textContent = window.PE_T('apply','Apply');

        /* Step 3: Compare prices — detect CODE-specific discount */
        var totalAfterDiscount = cartAfter.items.reduce(function(sum, item) {
          return sum + (item.final_line_price || item.final_price * item.quantity);
        }, 0);

        var codeDiscount = totalBeforeDiscount - totalAfterDiscount;
        /* Also check Shopify's own record of which discounts are active on
           the cart — a second, independent signal beyond the price diff
           (a 100%-off-shipping code, for example, wouldn't move item totals
           at all but IS legitimately applied). */
        var appliedNames = (cartAfter.cart_level_discount_applications || [])
          .map(function(d){ return (d.title || '').toUpperCase(); });
        /* Collection-restricted codes are LINE-level discounts: they never
           appear in cart_level_discount_applications. Check each item's
           discount records too — this is where "amount off products"
           codes actually show up in the Cart API. */
        var lineLevelHit = (cartAfter.items || []).some(function (it) {
          var allocs = it.line_level_discount_allocations || [];
          var discs  = it.discounts || [];
          return allocs.some(function (a) {
            return a && a.discount_application &&
                   (a.discount_application.title || '').toUpperCase() === code;
          }) || discs.some(function (d) {
            return (d.title || '').toUpperCase() === code;
          });
        });
        /* v34: Shopify's cart API reports each submitted code with an
           "applicable" flag — the authoritative signal. Only fall back to the
           heuristics when the field is absent. (Before v34 any line-level
           allocation, e.g. an automatic discount, made ANY code look valid.) */
        var dcs = Array.isArray(cartAfter.discount_codes) ? cartAfter.discount_codes : null;
        var dcHit = dcs ? dcs.filter(function (d) { return (d.code || '').toUpperCase() === code; })[0] : null;
        if (dcHit && dcHit.applicable === false) {
          fetch('/cart/update.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({ discount: '' }) })
            .then(function(r){ return r.json(); }).then(function(c){ refreshCart(c); }).catch(function(){});
          try { sessionStorage.removeItem('pe_discount_code'); } catch(e){}
          showMsg(window.PE_T('code_invalid_items','Code not valid for current items'), 'err');
          return;
        }
        var codeIsActive = (dcHit && dcHit.applicable === true) ||
          appliedNames.indexOf(code) > -1 || lineLevelHit || (!dcs && codeDiscount > 0);

        if (codeIsActive) {
          /* ✓ Code IS active on the cart — success! */
          try { sessionStorage.setItem('pe_discount_code', code); } catch(e){}
          var ckBtn = document.querySelector('.cd-checkout-btn');
          if (ckBtn) ckBtn.href = '/checkout?discount=' + encodeURIComponent(code);
          var savedMsg = codeDiscount > 0 ? (' ' + window.PE_T('you_save','— you save {amt}').replace('{amt}', PE_money(codeDiscount))) : '';
          showMsg(window.PE_T('code_applied','Code "{code}" applied').replace('{code}', code) + savedMsg, 'ok');
          refreshCart(cartAfter);
        } else {
          /* Cart AJAX could not confirm the discount. That does NOT mean the
             code is invalid: /cart/update.js discount support is undocumented
             and silently ignored on many shops, and Shopify never exposes a
             code's eligibility rules to theme JS. Before declaring the bag
             ineligible, check the merchant's own convention: the "descontos"
             collection contains exactly the products live codes apply to. */
          checkDescontosCollection(cartAfter.items || []).then(function (hasEligible) {
            if (hasEligible) {
              /* At least one bag item IS in the discount collection —
                 trust checkout to apply the code correctly. */
              try { sessionStorage.setItem('pe_discount_code', code); } catch(e){}
              /* Set the documented checkout cookie as well (GET /discount/CODE) */
              fetch('/discount/' + encodeURIComponent(code)).catch(function(){});
              var ckBtn2 = document.querySelector('.cd-checkout-btn');
              if (ckBtn2) ckBtn2.href = '/checkout?discount=' + encodeURIComponent(code);
              showMsg(window.PE_T('code_saved','Code "{code}" will apply at checkout').replace('{code}', code), 'ok');
            } else {
              /* Nothing in the bag belongs to the discount collection —
                 now the "not eligible" message is actually justified. */
              fetch('/cart/update.js', {
                method: 'POST',
                headers: {'Content-Type':'application/json'},
                body: JSON.stringify({ discount: '' })
              }).catch(function(){});
              try { sessionStorage.removeItem('pe_discount_code'); } catch(e){}
              showDiscountPopup(code, cartAfter.items || []);
              showMsg(window.PE_T('code_not_applicable','Code valid — not for your current bag products'), 'warn');
            }
          });
        }
      });
    })
    .catch(function() {
      applyBtn.disabled    = false;
      applyBtn.textContent = window.PE_T('apply','Apply');
      showMsg(window.PE_T('could_not_validate','Could not validate. Enter the code at checkout.'), 'warn');
    });
  }

  applyBtn.addEventListener('click', applyCode);
  input.addEventListener('keydown', function(e){ if (e.key === 'Enter') { e.preventDefault(); applyCode(); } });
})();

/* ── Exports ─────────────────────────────────────────────── */
window.cartAdd    = cartAdd;
window.cartChange = cartChange;
window.cartGet    = getCart;
window.renderCart = refreshCart;
window.peBumpCart = peBumpCart;
